import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { imgUrl } from '../utils/imgUrl';
import './Interests.css';

const Shortlists = () => {
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authService.getShortlists()
      .then(res => setProfiles(res.data))
      .finally(() => setLoading(false));
  }, []);

  const handleRemove = async (profileId) => {
    await authService.toggleShortlist(profileId);
    setProfiles(prev => prev.filter(p => p.id !== profileId));
  };

  return (
    <div className="interests-wrapper">
      <div className="interests-header">
        <button className="interests-back" onClick={() => navigate('/dashboard')}>← Back</button>
        <h2>♡ Shortlisted Profiles</h2>
        <span />
      </div>

      <div className="interests-body">
        {loading ? (
          <div className="interests-empty">Loading...</div>
        ) : profiles.length === 0 ? (
          <div className="interests-empty">No shortlisted profiles yet</div>
        ) : (
          profiles.map(profile => {
            const age = profile.date_of_birth
              ? Math.floor((new Date() - new Date(profile.date_of_birth)) / (365.25 * 24 * 60 * 60 * 1000))
              : null;
            const photo = profile.photos?.[0]?.photo_url || profile.profile_photo;
            const initials = `${profile.first_name?.[0] || ''}${profile.last_name?.[0] || ''}`;

            return (
              <div className="ic-card" key={profile.id}>
                <div className="ic-avatar" onClick={() => navigate(`/profile/${profile.id}`)}>
                  {photo ? <img src={imgUrl(photo)} alt={profile.first_name} /> : <span>{initials}</span>}
                </div>
                <div className="ic-info">
                  <h3 onClick={() => navigate(`/profile/${profile.id}`)}>{profile.first_name} {profile.last_name}</h3>
                  <div className="ic-meta">
                    {age && <span>{age} yrs</span>}
                    {profile.professional_details?.occupation && <span>{profile.professional_details.occupation}</span>}
                    {profile.location?.city && <span>📍 {profile.location.city}</span>}
                  </div>
                </div>
                <div className="ic-actions">
                  <button className="ic-btn-view" onClick={() => navigate(`/profile/${profile.id}`)}>View Profile</button>
                  <button className="ic-btn-decline" onClick={() => handleRemove(profile.id)}>✕ Remove</button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default Shortlists;
